// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMap$dOrdered from "../Data.Map.Ordered/index.js";
import * as Data$dMap$dSerialized from "../Data.Map.Serialized/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Data$dSet$dSerialized from "../Data.Set.Serialized/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTuple$dT2 from "../Data.Tuple.T2/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dI18n$dTypes from "../Restaumatic.I18n.Types/index.js";
import * as Restaumatic$dLocales from "../Restaumatic.Locales/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dAvailability from "../Restaumatic.Menu.V2.Types.Availability/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dMenuConsumer from "../Restaumatic.Menu.V2.Types.MenuConsumer/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric from "../Restaumatic.Menu.V2.Types.Parametric.Parametric/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dPhoto from "../Restaumatic.Menu.V2.Types.Photo/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dTags from "../Restaumatic.Menu.V2.Types.Tags/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const eq = /* #__PURE__ */ (() => Data$dMap$dInternal.eqMap(Data$dEq.eqString)(Data$dEq.eqString).eq)();
const eq1 = /* #__PURE__ */ (() => {
  const $0 = Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.eqParametric(Data$dEq.eqInt);
  return x => y => {
    if (x.tag === "Nothing") { return y.tag === "Nothing"; }
    if (x.tag === "Just") {
      if (y.tag === "Just") { return $0.eq(x._1)(y._1); }
      return false;
    }
    return false;
  };
})();
const eq4 = /* #__PURE__ */ (() => Data$dMap$dInternal.eqMap(Restaumatic$dLocales.eqLocale)(Data$dEq.eqString).eq)();
const eq8 = /* #__PURE__ */ Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl);
const eq9 = /* #__PURE__ */ (() => Data$dMap$dInternal.eqMap(Restaumatic$dMenu$dV2$dTypes$dTags.eqTag)(Data$dEq.eqUnit).eq)();
const eq10 = /* #__PURE__ */ (() => Data$dMap$dInternal.eqMap(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.eqMenuConsumer)(Data$dEq.eqUnit).eq)();
const customParameterValuesIsSymbol = {reflectSymbol: () => "customParameterValues"};
const priceOverrideIsSymbol = {reflectSymbol: () => "priceOverride"};
const productIsSymbol = {reflectSymbol: () => "product"};
const ComboChoiceIsSymbol = {reflectSymbol: () => "ComboChoice"};
const choicesIsSymbol = {reflectSymbol: () => "choices"};
const defaultChoiceIsSymbol = {reflectSymbol: () => "defaultChoice"};
const descriptionIsSymbol = {reflectSymbol: () => "description"};
const nameIsSymbol = {reflectSymbol: () => "name"};
const photoIsSymbol = {reflectSymbol: () => "photo"};
const skippableIsSymbol = {reflectSymbol: () => "skippable"};
const showMaybe = {
  show: v => {
    if (v.tag === "Just") { return "(Just " + Restaumatic$dMenu$dV2$dTypes$dPhoto.showPhoto.show(v._1) + ")"; }
    if (v.tag === "Nothing") { return "Nothing"; }
    $runtime.fail();
  }
};
const showTranslated = /* #__PURE__ */ Data$dMap$dInternal.showMap(Restaumatic$dLocales.showLocale)(Data$dShow.showString);
const ComboElementIsSymbol = {reflectSymbol: () => "ComboElement"};
const decodeMaybe = /* #__PURE__ */ Unscramble.decodeMaybe(Data$dUUID.udecodeUUID);
const udecodeTranslated = /* #__PURE__ */ Restaumatic$dI18n$dTypes.decodeMap(Unscramble.decodeString1);
const decodeRecordCons = /* #__PURE__ */ Unscramble.decodeRecordCons(descriptionIsSymbol)(udecodeTranslated);
const decodeRecordCons1 = /* #__PURE__ */ Unscramble.decodeRecordCons(nameIsSymbol)(udecodeTranslated);
const decodeRecordCons2 = /* #__PURE__ */ Unscramble.decodeRecordCons(photoIsSymbol)(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic$dMenu$dV2$dTypes$dPhoto.unscrambleDecodePhoto));
const availabilityIsSymbol = {reflectSymbol: () => "availability"};
const availabilityScheduleIsSymbol = {reflectSymbol: () => "availabilitySchedule"};
const crossSellingListIsSymbol = {reflectSymbol: () => "crossSellingList"};
const elementsIsSymbol = {reflectSymbol: () => "elements"};
const exchangeSuggestionListIsSymbol = {reflectSymbol: () => "exchangeSuggestionList"};
const tagsIsSymbol = {reflectSymbol: () => "tags"};
const visibleInIsSymbol = {reflectSymbol: () => "visibleIn"};
const ComboIsSymbol = {reflectSymbol: () => "Combo"};
const encodeWithOptionsOther = {encodeWithOptions: v => Data$dUUID.encodeUUID.encode};
const genericEncodeArgsArgument = {encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)};
const encodeWithOptionsOther1 = {
  encodeWithOptions: v => v2 => {
    if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
    if (v2.tag === "Just") {
      return Foreign$dGeneric$dClass.genericEncodeConstructor(Restaumatic$dMenu$dV2$dTypes$dPhoto.PhotoIsSymbol)({
        encodeArgs: opts => v$1 => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v$1), Data$dList$dTypes.Nil)
      }).encodeOpts(Foreign$dEncoding.options)(v2._1);
    }
    $runtime.fail();
  }
};
const encodeWithOptionsOther2 = /* #__PURE__ */ (() => {
  const encode1 = Restaumatic$dI18n$dTypes.encodeTranslated(Foreign$dGeneric$dClass.stringEncode).encode;
  return {encodeWithOptions: v => encode1};
})();
const encodeWithOptionsOther3 = {
  encodeWithOptions: v => v2 => {
    if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
    if (v2.tag === "Just") { return v2._1; }
    $runtime.fail();
  }
};
const decodeWithOptionsOther = {decodeWithOptions: v => Data$dUUID.decodeUUID.decode};
const genericDecodeArgsArgument = {decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument(decodeWithOptionsOther), decodeSingleRecordArg: Data$dMaybe.Nothing};
const decodeWithOptionsOther1 = {decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dMenu$dV2$dTypes$dPhoto.decodePhoto.decode)};
const decodeWithOptionsOther2 = /* #__PURE__ */ (() => {
  const decode2 = Restaumatic$dI18n$dTypes.decodeTranslated(Foreign$dGeneric$dClass.stringDecode).decode;
  return {decodeWithOptions: v => decode2};
})();
const decodeWithOptionsOther3 = {decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Data$dUUID.decodeUUID.decode)};
const ComboChoice = x => x;
const ComboElement = x => x;
const Combo = x => x;
const newtypeCombo_ = {Coercible0: () => {}};
const newtypeComboElement_ = {Coercible0: () => {}};
const newtypeComboChoice_ = {Coercible0: () => {}};
const hasFieldComboElement = dictHasField => dictHasField;
const hasFieldComboChoice = dictHasField => dictHasField;
const hasFieldCombo = dictHasField => dictHasField;
const eqComboChoice = {eq: x => y => eq(x.customParameterValues)(y.customParameterValues) && eq1(x.priceOverride)(y.priceOverride) && x.product === y.product};
const eq11 = /* #__PURE__ */ (() => Data$dMap$dOrdered.eqOMap(Data$dEq.eqString)(eqComboChoice).eq)();
const eqComboElement = {
  eq: x => y => eq11(x.choices)(y.choices) && (() => {
    if (x.defaultChoice.tag === "Nothing") { return y.defaultChoice.tag === "Nothing"; }
    if (x.defaultChoice.tag === "Just") {
      if (y.defaultChoice.tag === "Just") { return x.defaultChoice._1 === y.defaultChoice._1; }
      return false;
    }
    return false;
  })() && eq4(x.description)(y.description) && eq4(x.name)(y.name) && (() => {
    if (x.photo.tag === "Nothing") { return y.photo.tag === "Nothing"; }
    if (x.photo.tag === "Just") {
      if (y.photo.tag === "Just") { return x.photo._1 === y.photo._1; }
      return false;
    }
    return false;
  })() && x.skippable === y.skippable
};
const eq12 = /* #__PURE__ */ (() => Data$dMap$dOrdered.eqOMap(Data$dEq.eqString)(eqComboElement).eq)();
const eqCombo = {
  eq: x => y => (() => {
    if (x.availability.tag === "Available") { return y.availability.tag === "Available"; }
    if (x.availability.tag === "TemporarilyUnavailable") { return y.availability.tag === "TemporarilyUnavailable"; }
    if (x.availability.tag === "Hidden") { return y.availability.tag === "Hidden"; }
    return false;
  })() && (() => {
    if (x.availabilitySchedule.tag === "Nothing") { return y.availabilitySchedule.tag === "Nothing"; }
    if (x.availabilitySchedule.tag === "Just") {
      if (y.availabilitySchedule.tag === "Just") { return x.availabilitySchedule._1 === y.availabilitySchedule._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.crossSellingList.tag === "Nothing") { return y.crossSellingList.tag === "Nothing"; }
    if (x.crossSellingList.tag === "Just") {
      if (y.crossSellingList.tag === "Just") { return x.crossSellingList._1 === y.crossSellingList._1; }
      return false;
    }
    return false;
  })() && eq4(x.description)(y.description) && eq12(x.elements)(y.elements) && eq8(x.exchangeSuggestionList)(y.exchangeSuggestionList) && eq4(x.name)(y.name) && (() => {
    if (x.photo.tag === "Nothing") { return y.photo.tag === "Nothing"; }
    if (x.photo.tag === "Just") {
      if (y.photo.tag === "Just") { return x.photo._1 === y.photo._1; }
      return false;
    }
    return false;
  })() && eq9(x.tags)(y.tags) && eq10(x.visibleIn)(y.visibleIn)
};
const genericComboElement = {to: x => x, from: x => x};
const genericComboChoice = {to: x => x, from: x => x};
const showComboChoice = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.showParametric(Data$dMoney$dRounded.showMoney);
      const $1 = Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(Data$dUUID.showUUID);
      return {
        genericShowArgs: v => [
          "{ customParameterValues: " + $1.show(v.customParameterValues) + ", priceOverride: " + (() => {
            if (v.priceOverride.tag === "Just") { return "(Just " + $0.show(v.priceOverride._1) + ")"; }
            if (v.priceOverride.tag === "Nothing") { return "Nothing"; }
            $runtime.fail();
          })() + ", product: " + v.product + " " + "}"
        ]
      };
    })())(ComboChoiceIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const showComboElement = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dMap$dOrdered.showOMap(Data$dUUID.showUUID)(showComboChoice);
      return {
        genericShowArgs: v => [
          "{ choices: " + $0.show(v.choices) + (() => {
            if (v.defaultChoice.tag === "Just") {
              return ", defaultChoice: (Just " + v.defaultChoice._1 + ")" + ", description: " + showTranslated.show(v.description) + ", name: " + showTranslated.show(v.name) + ", photo: " + showMaybe.show(v.photo) + (v.skippable
                ? ", skippable: true "
                : ", skippable: false ");
            }
            if (v.defaultChoice.tag === "Nothing") {
              return ", defaultChoice: Nothing, description: " + showTranslated.show(v.description) + ", name: " + showTranslated.show(v.name) + ", photo: " + showMaybe.show(v.photo) + (v.skippable
                ? ", skippable: true "
                : ", skippable: false ");
            }
            $runtime.fail();
          })() + "}"
        ]
      };
    })())(ComboElementIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeComboChoice = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(customParameterValuesIsSymbol)(Unscramble.decodeMap(Data$dUUID.ufromJSONKeyUUID)(Data$dOrd.ordString)(Data$dUUID.udecodeUUID))(Unscramble.decodeRecordCons(priceOverrideIsSymbol)(Unscramble.decodeMaybe(Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.udecodeParametric(Data$dMoney$dRounded.udecodeMoney)))(Unscramble.decodeRecordCons(productIsSymbol)(Data$dUUID.udecodeUUID)(Unscramble.decodeRecordNil))).recordInfo(Type$dProxy.Proxy))
  }
))();
const unscrambleDecodeComboElement = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(choicesIsSymbol)(Data$dMap$dOrdered.udecodeMap(unscrambleDecodeComboChoice)(Data$dUUID.udecodeUUID)(Data$dOrd.ordString))(Unscramble.decodeRecordCons(defaultChoiceIsSymbol)(decodeMaybe)(decodeRecordCons(decodeRecordCons1(decodeRecordCons2(Unscramble.decodeRecordCons(skippableIsSymbol)(Unscramble.decodeBoolean1)(Unscramble.decodeRecordNil)))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericCombo = {to: x => x, from: x => x};
const showCombo = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dSet.showSet(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.showMenuConsumer);
      const $1 = Data$dSet.showSet(Restaumatic$dMenu$dV2$dTypes$dTags.showTag);
      const $2 = Data$dShow.showArrayImpl(Data$dUUID.toString);
      const $3 = Data$dMap$dOrdered.showOMap(Data$dUUID.showUUID)(showComboElement);
      return {
        genericShowArgs: v => [
          "{ availability: " + Restaumatic$dMenu$dV2$dTypes$dAvailability.showAvailability.show(v.availability) + (() => {
            if (v.availabilitySchedule.tag === "Just") {
              return ", availabilitySchedule: (Just " + v.availabilitySchedule._1 + ")" + (() => {
                if (v.crossSellingList.tag === "Just") {
                  return ", crossSellingList: (Just " + v.crossSellingList._1 + ")" + ", description: " + showTranslated.show(v.description) + ", elements: " + $3.show(v.elements) + ", exchangeSuggestionList: " + $2(v.exchangeSuggestionList) + ", name: " + showTranslated.show(v.name) + ", photo: " + showMaybe.show(v.photo) + ", tags: " + $1.show(v.tags) + ", visibleIn: " + $0.show(v.visibleIn) + " ";
                }
                if (v.crossSellingList.tag === "Nothing") {
                  return ", crossSellingList: Nothing, description: " + showTranslated.show(v.description) + ", elements: " + $3.show(v.elements) + ", exchangeSuggestionList: " + $2(v.exchangeSuggestionList) + ", name: " + showTranslated.show(v.name) + ", photo: " + showMaybe.show(v.photo) + ", tags: " + $1.show(v.tags) + ", visibleIn: " + $0.show(v.visibleIn) + " ";
                }
                $runtime.fail();
              })();
            }
            if (v.availabilitySchedule.tag === "Nothing") {
              if (v.crossSellingList.tag === "Just") {
                return ", availabilitySchedule: Nothing, crossSellingList: (Just " + v.crossSellingList._1 + ")" + ", description: " + showTranslated.show(v.description) + ", elements: " + $3.show(v.elements) + ", exchangeSuggestionList: " + $2(v.exchangeSuggestionList) + ", name: " + showTranslated.show(v.name) + ", photo: " + showMaybe.show(v.photo) + ", tags: " + $1.show(v.tags) + ", visibleIn: " + $0.show(v.visibleIn) + " ";
              }
              if (v.crossSellingList.tag === "Nothing") {
                return ", availabilitySchedule: Nothing, crossSellingList: Nothing, description: " + showTranslated.show(v.description) + ", elements: " + $3.show(v.elements) + ", exchangeSuggestionList: " + $2(v.exchangeSuggestionList) + ", name: " + showTranslated.show(v.name) + ", photo: " + showMaybe.show(v.photo) + ", tags: " + $1.show(v.tags) + ", visibleIn: " + $0.show(v.visibleIn) + " ";
              }
              $runtime.fail();
            }
            $runtime.fail();
          })() + "}"
        ]
      };
    })())(ComboIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeCombo = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(availabilityIsSymbol)(Restaumatic$dMenu$dV2$dTypes$dAvailability.unscrambleDecodeAvailability)(Unscramble.decodeRecordCons(availabilityScheduleIsSymbol)(decodeMaybe)(Unscramble.decodeRecordCons(crossSellingListIsSymbol)(decodeMaybe)(decodeRecordCons(Unscramble.decodeRecordCons(elementsIsSymbol)(Data$dMap$dOrdered.udecodeMap(unscrambleDecodeComboElement)(Data$dUUID.udecodeUUID)(Data$dOrd.ordString))(Unscramble.decodeRecordCons(exchangeSuggestionListIsSymbol)({
      unsafeDecode: Unscramble.decodeArray(Data$dUUID.udecodeUUID.unsafeDecode)
    })(decodeRecordCons1(decodeRecordCons2(Unscramble.decodeRecordCons(tagsIsSymbol)(Unscramble.decodeSet(Restaumatic$dMenu$dV2$dTypes$dTags.unscrambleDecodeTag)(Restaumatic$dMenu$dV2$dTypes$dTags.ordTag))(Unscramble.decodeRecordCons(visibleInIsSymbol)(Unscramble.decodeSet(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.unscrambleDecodeMenuConsumer)(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.ordMenuConsumer))(Unscramble.decodeRecordNil)))))))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeComboChoice = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericComboChoice)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(ComboChoiceIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(productIsSymbol)(encodeWithOptionsOther))(priceOverrideIsSymbol)((() => {
      const $0 = Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.encodeParametric(Data$dMoney$dRounded.encodeMoney)({
        encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", Data$dInt.toNumber(v) / 100.0), Data$dList$dTypes.Nil)
      });
      return {
        encodeWithOptions: v => v2 => {
          if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
          if (v2.tag === "Just") { return $0.encode(v2._1); }
          $runtime.fail();
        }
      };
    })()))(customParameterValuesIsSymbol)((() => {
      const encode1 = Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Data$dUUID.encodeUUID)(genericEncodeArgsArgument).encode;
      return {encodeWithOptions: v => encode1};
    })());
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeComboElement = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericComboElement)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(ComboElementIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(skippableIsSymbol)({
      encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
    }))(photoIsSymbol)(encodeWithOptionsOther1))(nameIsSymbol)(encodeWithOptionsOther2))(descriptionIsSymbol)(encodeWithOptionsOther2))(defaultChoiceIsSymbol)(encodeWithOptionsOther3))(choicesIsSymbol)((() => {
      const encode1 = Data$dMap$dOrdered.encodeMap({
        encode: Foreign$dEncoding.defaultEncode(Data$dTuple$dT2.genericT2)(Foreign$dGeneric$dClass.genericEncodeConstructor(Data$dTuple$dT2.T2IsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsProduct(genericEncodeArgsArgument)({
          encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", encodeComboChoice.encode(v)), Data$dList$dTypes.Nil)
        })))
      }).encode;
      return {encodeWithOptions: v => encode1};
    })());
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeCombo = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericCombo)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(ComboIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(visibleInIsSymbol)((() => {
      const encode1 = Data$dSet$dSerialized.encodeSet(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.encodeMenuConsumer).encode;
      return {encodeWithOptions: v => encode1};
    })()))(tagsIsSymbol)((() => {
      const encode1 = Data$dSet$dSerialized.encodeSet(Restaumatic$dMenu$dV2$dTypes$dTags.encodeTag).encode;
      return {encodeWithOptions: v => encode1};
    })()))(photoIsSymbol)(encodeWithOptionsOther1))(nameIsSymbol)(encodeWithOptionsOther2))(exchangeSuggestionListIsSymbol)((() => {
      const encode1 = Data$dFunctor.arrayMap(Data$dUUID.encodeUUID.encode);
      return {encodeWithOptions: v => encode1};
    })()))(elementsIsSymbol)((() => {
      const encode1 = Data$dMap$dOrdered.encodeMap({
        encode: Foreign$dEncoding.defaultEncode(Data$dTuple$dT2.genericT2)(Foreign$dGeneric$dClass.genericEncodeConstructor(Data$dTuple$dT2.T2IsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsProduct(genericEncodeArgsArgument)({
          encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", encodeComboElement.encode(v)), Data$dList$dTypes.Nil)
        })))
      }).encode;
      return {encodeWithOptions: v => encode1};
    })()))(descriptionIsSymbol)(encodeWithOptionsOther2))(crossSellingListIsSymbol)(encodeWithOptionsOther3))(availabilityScheduleIsSymbol)(encodeWithOptionsOther3))(availabilityIsSymbol)({
      encodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dAvailability.encodeAvailability.encode
    });
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeComboChoice = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericComboChoice)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ComboChoiceIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(productIsSymbol)(decodeWithOptionsOther)())(priceOverrideIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.decodeParametric(Data$dMoney$dRounded.decodeMoney)({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dMoney$dRounded.decodeMoney.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    }).decode);
    return {decodeWithOptions: v => decode2};
  })())())(customParameterValuesIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Data$dMap$dSerialized.decodeMap(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Data$dUUID.decodeUUID)(genericDecodeArgsArgument).decode;
    return {decodeWithOptions: v => decode2};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeComboElement = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericComboElement)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ComboElementIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(skippableIsSymbol)({
    decodeWithOptions: v => Foreign$dGeneric$dClass.booleanDecode.decode
  })())(photoIsSymbol)(decodeWithOptionsOther1)())(nameIsSymbol)(decodeWithOptionsOther2)())(descriptionIsSymbol)(decodeWithOptionsOther2)())(defaultChoiceIsSymbol)(decodeWithOptionsOther3)())(choicesIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Data$dMap$dOrdered.decodeMap(Data$dTuple$dT2.decodeT2(genericDecodeArgsArgument)({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => decodeComboChoice.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    }))(Data$dOrd.ordString).decode;
    return {decodeWithOptions: v => decode2};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeCombo = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericCombo)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ComboIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(visibleInIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Data$dSet$dSerialized.decodeSet(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.ordMenuConsumer)(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.decodeMenuConsumer).decode;
    return {decodeWithOptions: v => decode2};
  })())())(tagsIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Data$dSet$dSerialized.decodeSet(Restaumatic$dMenu$dV2$dTypes$dTags.ordTag)(Restaumatic$dMenu$dV2$dTypes$dTags.decodeTag).decode;
    return {decodeWithOptions: v => decode2};
  })())())(photoIsSymbol)(decodeWithOptionsOther1)())(nameIsSymbol)(decodeWithOptionsOther2)())(exchangeSuggestionListIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Foreign$dGeneric$dClass.arrayDecode(Data$dUUID.decodeUUID).decode;
    return {decodeWithOptions: v => decode2};
  })())())(elementsIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Data$dMap$dOrdered.decodeMap(Data$dTuple$dT2.decodeT2(genericDecodeArgsArgument)({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => decodeComboElement.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    }))(Data$dOrd.ordString).decode;
    return {decodeWithOptions: v => decode2};
  })())())(descriptionIsSymbol)(decodeWithOptionsOther2)())(crossSellingListIsSymbol)(decodeWithOptionsOther3)())(availabilityScheduleIsSymbol)(decodeWithOptionsOther3)())(availabilityIsSymbol)({
    decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dAvailability.decodeAvailability.decode
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  Combo,
  ComboChoice,
  ComboChoiceIsSymbol,
  ComboElement,
  ComboElementIsSymbol,
  ComboIsSymbol,
  availabilityIsSymbol,
  availabilityScheduleIsSymbol,
  choicesIsSymbol,
  crossSellingListIsSymbol,
  customParameterValuesIsSymbol,
  decodeCombo,
  decodeComboChoice,
  decodeComboElement,
  decodeMaybe,
  decodeRecordCons,
  decodeRecordCons1,
  decodeRecordCons2,
  decodeWithOptionsOther,
  decodeWithOptionsOther1,
  decodeWithOptionsOther2,
  decodeWithOptionsOther3,
  defaultChoiceIsSymbol,
  descriptionIsSymbol,
  elementsIsSymbol,
  encodeCombo,
  encodeComboChoice,
  encodeComboElement,
  encodeWithOptionsOther,
  encodeWithOptionsOther1,
  encodeWithOptionsOther2,
  encodeWithOptionsOther3,
  eq,
  eq1,
  eq10,
  eq11,
  eq12,
  eq4,
  eq8,
  eq9,
  eqCombo,
  eqComboChoice,
  eqComboElement,
  exchangeSuggestionListIsSymbol,
  genericCombo,
  genericComboChoice,
  genericComboElement,
  genericDecodeArgsArgument,
  genericEncodeArgsArgument,
  hasFieldCombo,
  hasFieldComboChoice,
  hasFieldComboElement,
  nameIsSymbol,
  newtypeComboChoice_,
  newtypeComboElement_,
  newtypeCombo_,
  photoIsSymbol,
  priceOverrideIsSymbol,
  productIsSymbol,
  showCombo,
  showComboChoice,
  showComboElement,
  showMaybe,
  showTranslated,
  skippableIsSymbol,
  tagsIsSymbol,
  udecodeTranslated,
  unscrambleDecodeCombo,
  unscrambleDecodeComboChoice,
  unscrambleDecodeComboElement,
  visibleInIsSymbol
};
